module.exports = __webpack_public_path__ + "assets/img/returnBtn-def11a4d.png";